module.exports = __webpack_public_path__ + "img/kyano-cards-logo-dark.fea4019f.svg";